import React from 'react';
import { translate } from '../../Services/translation';
import MiniCartProduct from './MiniCartProduct'
import constants from '../../constants';

const MiniCart = ({
    quantity,
    checkoutUrl,
    showInfo,
    toggle,
    update,
    orderRows,
    deliveryCost,
    dropshippingExtraCost,
    grandTotal,
    freightData,
    extendedOrderRows
}) => (
    <div className="cart cart--mini">
        <button className="cart__link--block" aria-label={translate('minicart.checkout')} onClick={() => toggle()}>
            <span className="cart__title">{translate('minicart.checkout')}</span>
            <i className="cart__icon">
                {quantity > 0 && <span className="cart__quantity">{quantity}</span>}
            </i>

        </button>
        <div
            className={`cart__dimmer${!showInfo ? ' cart__dimmer--hidden' : ''}`}
            onClick={() => toggle(false)}
        >
        </div>
        <div className={`cart__info${!showInfo ? ' cart__info--hidden' : ''}`}>
            <div className="cart-close-button-container">
                <span className="cart__close-button" onClick={() => toggle()}>x</span>
                <div>{translate('common.cart.close.button.text')}</div>
            </div>
            {extendedOrderRows.length ? (
                <div>
                    <h2>{translate('minicart.heading')}</h2>
                    {freightData &&
                        <div className="freight-data-heading">
                            <h3>{freightData.remainingAmountFormatted ? freightData.remainingAmountFormatted + " " : ""}{freightData.remainingText || ""} </h3>
                        </div>
                    }
                    <div className={`cart__product-row-container${!freightData ? ' bulky' : ''}`}>
                        {extendedOrderRows.map(orderRow => {
                            const { rowSystemId, quantity, multiple } = orderRow;
                            return (

                                <MiniCartProduct
                                    key={rowSystemId}
                                    product={orderRow}
                                    onCartItemIncrement={() => update(rowSystemId, quantity + multiple)}
                                    onCartItemDecrement={() => update(rowSystemId, quantity - multiple)}
                                    onCartItemRemove={() => update(rowSystemId, 0)}
                                />
                            );
                        })}
                    </div>
                    <div className="cart-summary-wrapper">
                        <div className="cart__summary">
                            <div className="cart__summary__info-row">
                                <div className="cart__split-row">
                                    <span className="cart__split-row__title">{translate(freightData && freightData.dropshipping ? 'common.checkout.orderinfo.dropshipping' : 'minicart.deliverycost')}</span>
                                    <span className="cart__split-row__delivery-total">{deliveryCost}</span>
                                </div>
                                {dropshippingExtraCost &&
                                    <div className="cart__split-row">
                                        <span className="cart__split-row__title">{translate('common.orderdetail.dropshippingextracost')}</span>
                                        <span className="cart__split-row__delivery-total">{dropshippingExtraCost}</span>
                                    </div>
                                }
                            </div>
                            <div className="cart__summary__info-row">

                                <div className="cart__split-row">
                                    <span className="cart__split-row__title">{translate('minicart.grandtotal')}</span>
                                    <span className="cart__split-row__total">{grandTotal}</span>
                                </div>
                                {constants.showVat &&
                                    <div className="text--right">{translate('minicart.taxesincluded')}</div>
                                }
                            </div>
                        </div>
                        <a href={checkoutUrl} className="cart__checkout-button">{translate('minicart.checkout')}</a>
                    </div>
                </div>
            ) : (
                <h2>{translate('minicart.emptyheading')}</h2>
            )}
        </div>
    </div>
)
export default MiniCart;